"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_finStatement = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, nodeToCopy, }) => {
    const friendlyName = `FinStatement`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.snakeCase(friendlyName)}_${suggestedSerialNumber}`,
            statement: 'balanceSheet',
            reportFrequency: 'month',
            csvArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('CSV WITH FIN STATEMENT'),
            rawArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('RAW SOURCE FILE (OPTIONAL)'),
            markupArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)('AI2CSV NODE THAT EXTRACTED RAW SOURCE FILE (OPTIONAL)'),
        },
    };
    if (nodeToCopy) {
        nodeData.configuration = (0, utils_1.copyNodeConfiguration)({
            nodeToCopy,
            isNode,
            nodeType: types_1.nodeType,
            suggestedSerialNumber,
        });
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ node, friendlyName, inputs, outputs, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_intermediateTape',
        'file_generatedSupplementalTape',
        'file_rawSupplementalTape',
    ];
    const errors = (0, utils_1.checkEdges)({
        friendlyName,
        inputs,
        outputs,
        isAllowedInputNode: (uiNode) => allowedInputNodes.some((type) => type === uiNode.nodeType),
        minInputs: 1,
        maxInputs: 3,
        minOutputs: 0,
        maxOutputs: 1000,
    });
    return errors;
};
const getTapeDefinition = ({ tapeBuilder, artifactId, }) => {
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(artifactId);
    (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, `tapeDefinitionResult is not valid for ${artifactId}`);
    (0, common_1.finleyAssert)(tapeDefinitionResult.data, `No definition found for ${artifactId}`);
    return tapeDefinitionResult.data;
};
const validateIntermediateTape = ({ graph, tape, tapeBuilder, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'finStatement', 'node is not a finStatement');
    const errors = [];
    const { csvArtifactSlug, rawArtifactSlug, markupArtifactSlug, } = tape.configuration;
    const artifactInputs = (0, utils_1.getDirectInputsForArtifact)({
        targetArtifactId: tape.id,
        ...graph,
    });
    const csvInput = artifactInputs.find((input) => input.artifactSlug === csvArtifactSlug);
    if (csvInput) {
        const tapeDefinition = getTapeDefinition({
            tapeBuilder,
            artifactId: csvInput.id,
        });
        const requiredFields = new Map([
            ['section', ['string']],
            ['ledgerName', ['string']],
            ['value', ['float', 'integer']],
        ]);
        const optionalFields = new Map([
            ['groups', ['string', 'optionalString']],
        ]);
        const invalidFieldNames = [];
        const invalidFieldTypes = [];
        tapeDefinition.baseFields.forEach((config) => {
            const { field: fieldName, type: fieldType } = config;
            const validTypes = requiredFields.get(fieldName);
            if (validTypes) {
                if (!validTypes.includes(fieldType)) {
                    invalidFieldTypes.push(`${fieldName} must be one of: [${validTypes.join(',')}]`);
                }
                // Remove from field set to return list of missing fields at the end
                requiredFields.delete(fieldName);
            }
            else {
                const optionalValidTypes = optionalFields.get(fieldName);
                if (optionalValidTypes) {
                    if (!optionalValidTypes.includes(fieldType)) {
                        invalidFieldTypes.push(`${fieldName} must be one of: [${optionalValidTypes.join(',')}]`);
                    }
                }
                else {
                    // Add to list of invalid fields
                    invalidFieldNames.push(config.field);
                }
            }
        });
        // Output invalid field types if any
        if (invalidFieldTypes.length > 0) {
            errors.push(`Invalid field types for expected properties: [${invalidFieldTypes.join(', ')}]`);
        }
        // Output invalid field names if any
        if (invalidFieldNames.length > 0) {
            errors.push(`Fields not allowed for fin statement: [${invalidFieldNames.join(', ')}]`);
        }
        // Output missing fields if any
        const missingFields = Array.from(requiredFields.keys());
        if (missingFields.length > 0) {
            errors.push(`Fields missing for fin statment: [${missingFields.join(', ')}]`);
        }
    }
    else {
        errors.push(`finStatement: [${tape.artifactSlug}] cannot find [inputArtifact:${csvArtifactSlug}] listed as an input dependency.`);
    }
    if (rawArtifactSlug) {
        const rawInput = artifactInputs.find((input) => input.artifactSlug === rawArtifactSlug);
        if (!rawInput) {
            errors.push(`finStatement: [${tape.artifactSlug}] cannot find [inputArtifact:${rawArtifactSlug}] listed as an input dependency.`);
        }
    }
    if (markupArtifactSlug) {
        const markupInput = artifactInputs.find((input) => input.artifactSlug === markupArtifactSlug);
        if (!markupInput) {
            errors.push(`finStatement: [${tape.artifactSlug}] cannot find [inputArtifact:${markupInput}] listed as an input dependency.`);
        }
    }
    return errors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_finStatement = {
    nodeTypeText: 'FinStatement',
    nodeType: types_1.nodeType,
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    badgeTexts: ['Financials'],
    createNewNode,
    isNode,
    isIntermediateRecord,
    ...otherProps,
    hasValidConfig,
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map